import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function Connexion() {
  const navigate = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [erreur, setErreur] = useState('')

  const connecter = async (e) => {
    e.preventDefault()
    setErreur('')
    setLoading(true)
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    setLoading(false)
    if (error) return setErreur('Email ou mot de passe incorrect.')
    navigate('/tableau-de-bord')
  }

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>⭐</div>
          <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: 28, fontWeight: 900, color: '#1a2e5a', margin: 0 }}>
            Kudo<span style={{ color: '#2d7dd2' }}>Genius</span>
          </h1>
          <p style={{ color: '#6b7280', fontSize: 14, marginTop: 6 }}>Connexion espace parents</p>
        </div>

        <form onSubmit={connecter} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div>
            <label style={labelStyle}>Adresse email</label>
            <input type="email" required value={email} onChange={e => setEmail(e.target.value)}
              className="input" placeholder="ton@email.com" autoComplete="email" />
          </div>
          <div>
            <label style={labelStyle}>Mot de passe</label>
            <input type="password" required value={password} onChange={e => setPassword(e.target.value)}
              className="input" placeholder="Ton mot de passe" autoComplete="current-password" />
          </div>

          {erreur && <div style={{ background: '#FEE2E2', color: '#DC2626', borderRadius: 10, padding: '10px 14px', fontSize: 14, fontWeight: 700 }}>{erreur}</div>}

          <button type="submit" disabled={loading} style={btnStyle}>
            {loading ? 'Connexion...' : 'Se connecter →'}
          </button>
        </form>

        <div style={{ marginTop: 16, textAlign: 'center' }}>
          <Link to="/mot-de-passe-oublie" style={{ color: '#2d7dd2', fontSize: 13, fontWeight: 700 }}>
            Mot de passe oublié ?
          </Link>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, color: '#6b7280', fontSize: 14 }}>
          Pas encore de compte ? <Link to="/inscription" style={{ color: '#2d7dd2', fontWeight: 800 }}>Créer un compte</Link>
        </p>

        <div style={{ marginTop: 28, padding: '16px', background: '#f0fdf4', borderRadius: 12, border: '1px solid #BBF7D0' }}>
          <p style={{ fontSize: 13, color: '#166534', fontWeight: 700, textAlign: 'center' }}>🏫 Vous êtes un enseignant ?</p>
          <p style={{ fontSize: 12, color: '#15803D', textAlign: 'center', marginTop: 4 }}>
            <Link to="/acces-ecole" style={{ color: '#15803D', fontWeight: 800, textDecoration: 'underline' }}>
              Accès école avec votre code →
            </Link>
          </p>
        </div>

        <div style={{ marginTop: 12, padding: '16px', background: '#f0f9ff', borderRadius: 12, border: '1px solid #BAE6FD' }}>
          <p style={{ fontSize: 13, color: '#075985', fontWeight: 700, textAlign: 'center' }}>🩺 Vous êtes thérapeute ?</p>
          <p style={{ fontSize: 12, color: '#0369a1', textAlign: 'center', marginTop: 4 }}>
            <Link to="/acces-therapeute" style={{ color: '#0369a1', fontWeight: 800, textDecoration: 'underline' }}>
              Accès thérapeute avec votre code →
            </Link>
          </p>
        </div>

        <p style={{ textAlign: 'center', marginTop: 20, color: '#9ca3af', fontSize: 11 }}>
          Un outil offert par <a href="https://nutrygenius.com" target="_blank" rel="noreferrer" style={{ color: '#2d7dd2' }}>NutryGenius®</a>
        </p>
        <p style={{ textAlign: 'center', marginTop: 8, color: '#9ca3af', fontSize: 10 }}>
          <Link to="/mentions-legales" style={{ color: '#9ca3af' }}>Mentions légales</Link>
          <span style={{ margin: '0 8px' }}>·</span>
          <Link to="/politique-confidentialite" style={{ color: '#9ca3af' }}>Politique de confidentialité</Link>
        </p>
      </div>
    </div>
  )
}

const containerStyle = {
  minHeight: '100vh', background: '#f0f6ff',
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
}
const cardStyle = {
  background: '#fff', borderRadius: 24, padding: '40px 36px',
  maxWidth: 440, width: '100%',
  boxShadow: '0 8px 40px rgba(45,125,210,0.12)',
  border: '1px solid #dbeafe'
}
const btnStyle = {
  width: '100%', padding: '14px', borderRadius: 30, border: 'none',
  background: '#2d7dd2', color: '#fff', fontSize: 16, fontWeight: 800,
  cursor: 'pointer', fontFamily: "'Nunito', sans-serif",
  boxShadow: '0 4px 15px rgba(45,125,210,0.3)', marginTop: 8
}
const labelStyle = { display: 'block', fontSize: 13, fontWeight: 800, color: '#374151', marginBottom: 6 }
